// extracted by mini-css-extract-plugin
export var lg = "_11-4";
export var md = "_11-3";
export var sm = "_11-2";
export var xs = "_11-1";
export var xxs = "_11-0";